exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.profile[data-v-caf9f426]{height:100%}div.content[data-v-caf9f426]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}", ""]);

// exports
